import { Flex, Heading, Button, Text, Divider } from "@chakra-ui/react"
import Navbar from "./Navbar"

const Header = ({ onPlansClick }) => {
  return (
    <>
      <Navbar />
      <Flex
        backgroundImage={[
          "url(/cez-confort-asigurat/assets/hero-background-mobile.jpg)",
          "url(/cez-confort-asigurat/assets/hero-background.jpg)",
          "url(/cez-confort-asigurat/assets/hero-background.jpg)",
          "url(/cez-confort-asigurat/assets/hero-background.jpg)",
        ]}
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        height="80vh"
        flexDirection="row"
        alignItems="center"
        paddingLeft="10vw"
        paddingRight="10vw"
      >
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          width={["100vw", "100vw", "40vw", "30vw"]}
          backgroundColor="white"
          padding="24px"
          boxShadow="xs"
          borderRadius="10px"
        >
          <Heading
            color="brand.400"
            marginBottom={["8px", "8px", "16px", "16px"]}
            textAlign={["center", "center", "left", "left"]}
          >
            CEZ Confort Asigurat
          </Heading>
          <Divider />
          <Text
            marginTop={["8px", "8px", "16px", "16px"]}
            textAlign={["center", "center", "left", "left"]}
          >
            Alege noul produs de energie electrica: iti ofera inclusiv asigurari
            si asistenta de urgenta pentru casa ta!
          </Text>
          <Flex
            width="100%"
            flexDirection={["column", "column", "row", "row"]}
            alignItems="center"
            justifyContent={["center", "center", "flex-start", "flex-start"]}
          >
            <Button
              colorScheme="brand"
              variant="solid"
              marginTop={["16px", "24px", "24px"]}
              marginRight={["0px", "0px", "8px", "8px"]}
              onClick={(e) => {
                e.preventDefault()
                window.location.href =
                  "https://mycez.cezinfo.ro/ro/web/client-non-cez/cere-oferta"
              }}
            >
              Solicita oferta
            </Button>
            <Button
              colorScheme="brand"
              variant="outline"
              marginTop={["16px", "24px", "24px"]}
              marginLeft={["0px", "0px", "8px", "8px"]}
              onClick={() => onPlansClick()}
            >
              Vezi planurile
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}

export default Header
